import { INJECTED_ICON_CSS } from './Dropdown.style';

export const INJECTED_ICON_CLASS = 'dropdown-icon-injected';

// DocumentIcon SVG — can't import the React component into a DOM-injection context
const PAPER_ICON_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" aria-hidden="true" width="1em" height="1em"><path fill-rule="evenodd" d="M3.316 1.46a.202.202 0 00-.202.203v12.674c0 .112.09.202.202.202h9.368c.112 0 .202-.09.202-.202V7.724c0-1.024-.83-1.854-1.855-1.854H9.929c-.802 0-1.452-.65-1.452-1.452V3.316c0-1.025-.83-1.855-1.855-1.855H3.316zm0-1.25c-.802 0-1.452.65-1.452 1.453v12.674c0 .802.65 1.452 1.452 1.452h9.368c.802 0 1.452-.65 1.452-1.452V7.45A7.238 7.238 0 006.898.21H3.316zm6.133 1.82c.179.392.278.827.278 1.286v1.102c0 .111.09.202.202.202h1.102c.458 0 .894.099 1.286.277A6.012 6.012 0 009.449 2.03z"/></svg>';

export function insertInjectedIcon(idsItem: HTMLElement, componentInstanceId: string): void {
    // re-apply each call: Interstate can reset inline styles it didn't set on re-render
    const currentPosition = getComputedStyle(idsItem).position;
    if (currentPosition === 'static' || currentPosition === '') {
        idsItem.style.position = 'relative';
    }

    const alreadyInjected = idsItem.querySelector(`.${INJECTED_ICON_CLASS}[data-component-instance-id="${componentInstanceId}"]`);
    if (alreadyInjected) return;

    const iconSpan = document.createElement('span');
    iconSpan.className = INJECTED_ICON_CLASS;
    iconSpan.dataset.componentInstanceId = componentInstanceId;
    iconSpan.style.cssText = INJECTED_ICON_CSS;
    iconSpan.style.left = getComputedStyle(idsItem).paddingLeft || '0px';
    iconSpan.innerHTML = PAPER_ICON_SVG;

    idsItem.appendChild(iconSpan);
}
